import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec81f961"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "reviews" }
const _hoisted_2 = { class: "tp-course-details-2-main-title" }
const _hoisted_3 = { class: "tp-course-details-2-review-rating" }
const _hoisted_4 = { class: "row gx-2" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "tp-course-details-2-review-rating-info text-center placeholder-glow" }
const _hoisted_7 = {
  key: 0,
  class: "placeholder d-block rounded",
  style: {"width":"100%","height":"120px"}
}
const _hoisted_8 = { class: "course-star-rating d-inline-block mt-2" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\" data-v-ec81f961><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i></div>", 1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i>", 5)
const _hoisted_15 = [
  _hoisted_10
]
const _hoisted_16 = { class: "col-lg-8" }
const _hoisted_17 = { class: "tp-course-details-2-review-details" }
const _hoisted_18 = { class: "tp-course-details-2-review-content placeholder-glow" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<span class=\"placeholder d-block rounded\" style=\"width:100%;height:10px;margin-bottom:15px;\" data-v-ec81f961></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:10px;margin-bottom:15px;\" data-v-ec81f961></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:10px;margin-bottom:15px;\" data-v-ec81f961></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:10px;margin-bottom:15px;\" data-v-ec81f961></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:10px;\" data-v-ec81f961></span>", 5)
const _hoisted_24 = { class: "tp-course-details-2-review-item d-flex align-items-center justify-content-between" }
const _hoisted_25 = { class: "tp-course-details-2-review-text" }
const _hoisted_26 = { class: "tp-course-details-2-review-progress" }
const _hoisted_27 = ["data-width"]
const _hoisted_28 = { class: "tp-course-details-2-review-percent" }
const _hoisted_29 = { class: "tp-course-details-2-review-item d-flex align-items-center justify-content-between" }
const _hoisted_30 = { class: "tp-course-details-2-review-text" }
const _hoisted_31 = { class: "tp-course-details-2-review-progress" }
const _hoisted_32 = ["data-width"]
const _hoisted_33 = { class: "tp-course-details-2-review-percent" }
const _hoisted_34 = { class: "tp-course-details-2-review-item d-flex align-items-center justify-content-between" }
const _hoisted_35 = { class: "tp-course-details-2-review-text" }
const _hoisted_36 = { class: "tp-course-details-2-review-progress" }
const _hoisted_37 = ["data-width"]
const _hoisted_38 = { class: "tp-course-details-2-review-percent" }
const _hoisted_39 = { class: "tp-course-details-2-review-item d-flex align-items-center justify-content-between" }
const _hoisted_40 = { class: "tp-course-details-2-review-text" }
const _hoisted_41 = { class: "tp-course-details-2-review-progress" }
const _hoisted_42 = ["data-width"]
const _hoisted_43 = { class: "tp-course-details-2-review-percent" }
const _hoisted_44 = { class: "tp-course-details-2-review-item d-flex align-items-center justify-content-between" }
const _hoisted_45 = { class: "tp-course-details-2-review-text" }
const _hoisted_46 = { class: "tp-course-details-2-review-progress" }
const _hoisted_47 = ["data-width"]
const _hoisted_48 = { class: "tp-course-details-2-review-percent" }
const _hoisted_49 = { class: "tp-course-details-2-main-title" }
const _hoisted_50 = { class: "text-secondary" }
const _hoisted_51 = { class: "tp-course-details-2-review-reply-wrap" }
const _hoisted_52 = {
  key: 0,
  class: "tp-course-details-2-review-item-reply placeholder-glow"
}
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-course-details-2-review-top d-flex\" data-v-ec81f961><div class=\"tp-course-details-2-review-thumb\" data-v-ec81f961><span class=\"placeholder d-inline-block rounded-circle\" style=\"width:50px;height:50px;\" data-v-ec81f961></span></div><div class=\"tp-course-details-2-review-content\" data-v-ec81f961><span class=\"placeholder d-block rounded\" style=\"width:80px;height:18px;margin:8px 0 6px 0;\" data-v-ec81f961></span><span class=\"placeholder d-block rounded\" style=\"width:50px;height:8px;\" data-v-ec81f961></span></div></div><span class=\"placeholder d-block rounded\" style=\"width:100%;height:10px;margin-bottom:12px;\" data-v-ec81f961></span><span class=\"placeholder d-block rounded\" style=\"width:35%;height:10px;\" data-v-ec81f961></span>", 3)
const _hoisted_56 = [
  _hoisted_53
]
const _hoisted_57 = ["id"]
const _hoisted_58 = { class: "tp-course-details-2-review-top d-flex" }
const _hoisted_59 = { class: "tp-course-details-2-review-thumb" }
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "tp-course-details-2-review-content" }
const _hoisted_62 = { class: "tp-course-details-2-review-star d-flex align-items-center gap-1" }
const _hoisted_63 = { class: "course-star-rating star-rating-sm d-inline-block" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\" data-v-ec81f961><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i></div>", 1)
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i><i class=\"fa fa-star\" data-v-ec81f961></i>", 5)
const _hoisted_70 = [
  _hoisted_65
]
const _hoisted_71 = ["tooltip"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-clock mr-1" }, null, -1 /* HOISTED */))
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = {
  key: 1,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon-xl",
  src: "/assets/lms/icons/comment.svg",
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_76 = { class: "empty-state-text" }
const _hoisted_77 = { class: "m-0" }
const _hoisted_78 = { class: "text-secondary" }
const _hoisted_79 = { class: "tp-course-details-2-main-title" }
const _hoisted_80 = {
  key: 0,
  class: "tp-course-details-2-comment-box pr-25"
}
const _hoisted_81 = { class: "tp-course-details-2-comment-star" }
const _hoisted_82 = {
  class: "star-rating d-inline-block mt-1 mb-2",
  style: {"direction":"rtl"}
}
const _hoisted_83 = ["onClick", "onMouseover"]
const _hoisted_84 = { class: "tp-contact-input-form" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-xl-12" }
const _hoisted_87 = { class: "tp-contact-input p-relative" }
const _hoisted_88 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))
const _hoisted_90 = { class: "tp-contact-btn" }
const _hoisted_91 = ["disabled"]
const _hoisted_92 = {
  key: 0,
  class: "spinner-border spinner-border-sm mr-1",
  "aria-hidden": "true"
}
const _hoisted_93 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString($setup.lms_website.__('Student Feedback')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              ($data.reviews.is_loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                : _createCommentVNode("v-if", true),
              (!$data.reviews.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("h5", null, _toDisplayString($options.totalRate), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", {
                        class: "front-stars",
                        style: _normalizeStyle('width:'+$options.avg_rating_width($options.totalRate,0))
                      }, _hoisted_15, 4 /* STYLE */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString($setup.lms_website.__('Rated {0} out of 5', [$options.totalRate])), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                ($data.reviews.is_loading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_19
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (!$data.reviews.is_loading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('5 stars')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", {
                            class: "single-progress",
                            "data-width": $data.reviews.percentage['5_star']+'%'
                          }, null, 8 /* PROPS */, _hoisted_27)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("h5", null, _toDisplayString($data.reviews.percentage['5_star']) + "%", 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('4 stars')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", {
                            class: "single-progress",
                            "data-width": $data.reviews.percentage['4_star']+'%'
                          }, null, 8 /* PROPS */, _hoisted_32)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("h5", null, _toDisplayString($data.reviews.percentage['4_star']) + "%", 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('3 stars')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", {
                            class: "single-progress",
                            "data-width": $data.reviews.percentage['3_star']+'%'
                          }, null, 8 /* PROPS */, _hoisted_37)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("h5", null, _toDisplayString($data.reviews.percentage['3_star']) + "%", 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('2 stars')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", {
                            class: "single-progress",
                            "data-width": $data.reviews.percentage['2_star']+'%'
                          }, null, 8 /* PROPS */, _hoisted_42)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("h5", null, _toDisplayString($data.reviews.percentage['2_star']) + "%", 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('1 star')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", {
                            class: "single-progress",
                            "data-width": $data.reviews.percentage['1_star']+'%'
                          }, null, 8 /* PROPS */, _hoisted_47)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("h5", null, _toDisplayString($data.reviews.percentage['1_star']) + "%", 1 /* TEXT */)
                        ])
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("h4", _hoisted_49, [
      _createTextVNode(_toDisplayString($setup.lms_website.__('Featured Reviews')) + " ", 1 /* TEXT */),
      _createElementVNode("small", _hoisted_50, "(" + _toDisplayString($data.reviews.list.length) + ")", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_51, [
      ($data.reviews.is_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_56))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleReviews, (review) => {
        return (_openBlock(), _createElementBlock("div", {
          key: review.name,
          class: "tp-course-details-2-review-item-reply placeholder-glow animate__animated animate__zoomIn",
          id: `review-item-${review.name}`
        }, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("img", {
                src: (review.user_data?.user_image)?review.user_data?.user_image:'/assets/lms_website/images/user.png',
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_60)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("h4", null, _toDisplayString(review.user_data?.full_name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("div", {
                    class: "front-stars",
                    style: _normalizeStyle(`width: ${$options.avg_rating_width((review.rating*5))};`)
                  }, _hoisted_70, 4 /* STYLE */)
                ]),
                _createElementVNode("span", {
                  class: "span",
                  tooltip: $setup.moment(review.creation).format('DD MMM, YYYY - hh:mm a')
                }, [
                  _hoisted_72,
                  _createTextVNode(" " + _toDisplayString($setup.timeAgo(review.creation)), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_71)
              ])
            ])
          ]),
          _createElementVNode("p", {
            innerHTML: $options.formatTextWithBreaks(review.review)
          }, null, 8 /* PROPS */, _hoisted_73)
        ], 8 /* PROPS */, _hoisted_57))
      }), 128 /* KEYED_FRAGMENT */)),
      (!$options.visibleReviews.length && !$data.reviews.is_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
            _hoisted_75,
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("h5", _hoisted_77, _toDisplayString($setup.lms_website.__('Review the course')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_78, _toDisplayString($setup.lms_website.__('Help us improve our course material.')), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($options.visibleReviews.length < $data.reviews.list.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "tp-course-details-2-review-reply-btn pointer-event",
            onClick: _cache[0] || (_cache[0] = $event => ($options.loadMore()))
          }, [
            _createElementVNode("a", null, _toDisplayString($setup.lms_website.__('Show More Reviews')) + " (" + _toDisplayString(($data.reviews.list.length - $options.visibleReviews.length)) + ")", 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($props.courseEnrolled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h4", _hoisted_79, _toDisplayString($setup.lms_website.__('Write a Review')), 1 /* TEXT */),
          (!$data.rating?.is_reviewed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("span", null, _toDisplayString($setup.lms_website.__('What is it like to Course?')), 1 /* TEXT */),
                _createElementVNode("form", {
                  id: "contact-form",
                  class: _normalizeClass({'form-loading':($data.rating.form_lading)}),
                  method: "post",
                  onSubmit: _cache[3] || (_cache[3] = $event => ($options.submit_review($event)))
                }, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.rating.stars, (star) => {
                        return (_openBlock(), _createElementBlock("i", {
                          key: star,
                          class: _normalizeClass([['fa-star', $data.rating.value >= star || $data.rating.hoverRating >= star ? 'fas' : 'far'], "fa"]),
                          onClick: $event => ($options.setRating(star)),
                          onMouseover: $event => ($options.setHoverRating(star)),
                          onMouseleave: _cache[1] || (_cache[1] = (...args) => ($options.resetHoverRating && $options.resetHoverRating(...args)))
                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_83))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("label", null, _toDisplayString($setup.lms_website.__('Review Content')), 1 /* TEXT */),
                          _withDirectives(_createElementVNode("textarea", {
                            name: "rating_content",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.rating.content) = $event)),
                            class: _normalizeClass({'is-invalid':($data.rating.errors.content)}),
                            required: ""
                          }, null, 2 /* CLASS */), [
                            [_vModelText, $data.rating.content]
                          ]),
                          ($data.rating.errors.content)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _hoisted_89,
                                _createTextVNode(" " + _toDisplayString($data.rating.errors.content), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "tp-btn-inner",
                          disabled: !$data.rating.value || !$data.rating.content
                        }, [
                          ($data.rating.form_lading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_92))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Submit Review')), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_91)
                      ])
                    ])
                  ])
                ], 34 /* CLASS, NEED_HYDRATION */)
              ]))
            : _createCommentVNode("v-if", true),
          ($data.rating?.is_reviewed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                _hoisted_94,
                _createTextVNode(" " + _toDisplayString($setup.lms_website.__('You have already written a review.')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}